import React, { useEffect, useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import Posts from './Posts';
import { useFilter } from '../utils/hooks/use-filter';
import Filter from '../components/Filter';

export default function () {
  const { posts } = useFilter();
  const [paginatedPosts, setPaginatedPosts] = useState();
  const [blogsPageCount, setBlogsPageCount] = useState(0);
  // const loadMoreRef = useRef();

  const paginatePosts = () => {
    const n = 10;
    const arr = [];
    let i = 0;
    while (i < posts?.length) arr.push(posts.slice(i, (i += n)));
    setPaginatedPosts(arr);
  };

  useEffect(() => {
    paginatePosts();
  }, [posts]);

  // ! Infinite scroll (removed because conflicts with header CTA)
  // const onLoadMore = () => {
  //   if (typeof window !== `undefined` && loadMoreRef?.current) {
  //     const offset = loadMoreRef.current.offsetTop;
  //     const viewHeight = window.innerHeight * 0.75;
  //     const scrollPos = window.scrollY;
  //     if (offset - viewHeight < scrollPos) setBlogsPageCount((val) => val + 1);
  //   }
  // };

  // useEffect(() => {
  //   if (typeof window !== `undefined`) {
  //     const throttled = throttle(onLoadMore, 1000);
  //     window.addEventListener('scroll', throttled);

  //     return () => {
  //       window.removeEventListener('scroll', throttled);
  //     };
  //   }
  // }, []);

  return (
    <>
      <Filter posts={posts} />
      <p>{`${posts.length} result${posts.length !== 1 ? 's' : ''}`}</p>
      {paginatedPosts?.map((arr, i) => {
        if (i > blogsPageCount) return null;
        return <Posts posts={arr} idx={i} key={i} />;
      })}
      {paginatedPosts?.length > 0 && (
        <div className="load-more">
          {blogsPageCount + 1 < paginatedPosts?.length && (
            <button
              // ref={loadMoreRef}
              onClick={() => setBlogsPageCount((val) => val + 1)}
              type="button"
            >
              LOAD MORE
            </button>
          )}
        </div>
      )}
    </>
  );
}
